import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { loadMessages } from 'devextreme/localization';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { SalaryService } from 'src/app/shared/services/hr/salary.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { HrserviceService } from '../hrservice.service';

@Component({
  selector: 'app-approve-employee-resignation',
  templateUrl: './approve-employee-resignation.component.html',
  styleUrls: ['./approve-employee-resignation.component.scss']
})
export class ApproveEmployeeResignationComponent implements OnInit {
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;
   customDataSource: any[] = [];
  button: any;
  addpopup: string = ''

  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  employeeDropDown: any;
  employeeStatus: any;
    approvepermission : boolean = true;

  constructor(public gt: genericCustomStoreService,public translate: TranslateService,  private salaryServic: SalaryService, 
    Objects: ObjectsService, public router: Router,public NotifyService: NotifyService, public _publicSettingService: publicSettingService,public hr:HrserviceService) { 
       
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );
       gt.getdropdowndata("Employee", `GetDropDown?isOnJobOnly=false`).subscribe((res:any)=>{
      // this.employeeDropDown=res.data;
      this.employeeDropDown=res;
      //this.grid.instance.refresh()
      gt.getdropdowndata("EmployeeResignation").subscribe((res2:any)=>{
      // this.employeeDropDown=res.data;
        res2.forEach((element: any) => {
          const emp = this.employeeDropDown.find((x: any) => x.id == element.employeeId)
          element.branchName = emp?.branchName;
          element.notionalId = emp?.notionalId;
          element.userName = emp?.userName;
        });
        console.log(res2);
        this.customDataSource=res2;
      })
    })
      gt.getdropdowndata("EmployeeResignation","GetDropDown/ApprovedStatus").subscribe((res: []) => this.employeeStatus = res)
  
  
    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
     });

     this.onRowUpdated = this.onRowUpdated.bind(this);
     this.onSaving = this.onSaving.bind(this);


    }

    onRowUpdated(e: any) {
  console.log('Row updated:', e);
}

onSaving(e: any) {
  console.log('Saving event:', e);
}

ngOnInit(): void {
}

allowEditing = false; // يبدأ غير قابل للتعديل

  editingConfig = {
    mode: 'cell',
    allowUpdating: false, // ممنوع في الأول
    allowAdding: false,
    allowDeleting: false
  };

  ngAfterViewInit(): void {
    // بعد العرض بالكامل، اسمح بالتعديل
    setTimeout(() => {
      this.allowEditing = true;
      this.editingConfig = {
        ...this.editingConfig,
        allowUpdating: true
      };
    });
  }


submitapproval = async (e: any) => {

  debugger
  // const currentStatus = e.row.data.status;
  //  if(e.row.data.status == 3)
  //   return;
  // const statusFlow = [2, 3, 4];
  // const nextIndex = (statusFlow.indexOf(currentStatus) + 1) % statusFlow.length;
  // const nextStatus = statusFlow[nextIndex];

  const id = e.row.data.id;
  const nextStatus = e.row.data.status;
  if (!id) return;

  const payload = {
    id: id,
    status: nextStatus
  };

 

//e.row.data.status = nextStatus;
  try {
    await this.hr.ApproveEmployeeResignation(payload);
    this.NotifyService.notifyfun('edit');

    // ✅ Soft refresh + force data reload from backend
    await this.grid.instance.refresh();
    await this.grid.instance.getDataSource().reload();
  } catch (err: any) {
    console.error('Approval failed:', err);
    this.NotifyService.notifyfunerr(err);
  }
};






}
